import Compressor from 'compressorjs'

export function compressImageFile(file: File): Promise<string> {
  return new Promise((resolve, reject) => new Compressor(file, {
    maxWidth: 768,
    maxHeight: 768,
    quality: 0.95,
    mimeType: 'image/jpeg',
    success(result) {
      const reader = new FileReader()
      reader.onerror = reject
      reader.onload = () => resolve(reader.result as string)
      reader.readAsDataURL(result)
    },
    error: reject,
  }))
}
